import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const AppFooter = () => {
    return (_jsxs("div", { className: "layout-footer", dir: 'ltr', children: ["Powered By:", _jsx("span", { className: "font-medium ml-2", children: "Parsa Technologies" })] }));
};
export default AppFooter;
